import { useQuery } from '@tanstack/react-query'
import { rawRequest } from '@/api/http'

// ── qtz-readiness GET /api/v1/version ───────────────────────────────────────
// A bare {service, version}, not the {success, data} envelope. The user menu
// shows it beside the portal's own version so a stale deployment is visible.

export interface ServiceVersion {
  service: string
  version: string
}

export const versionApi = {
  async service(): Promise<ServiceVersion | null> {
    const r = await rawRequest('/api/v1/version')
    if (!r.ok) return null
    const body = (await r.json()) as Partial<ServiceVersion>
    return typeof body.version === 'string' ? { service: body.service ?? 'qtz-readiness', version: body.version } : null
  },
}

// The service's version, read once per page load; null when it does not answer.
export function useServiceVersion() {
  return useQuery({ queryKey: ['service-version'], queryFn: versionApi.service, staleTime: Infinity, retry: false })
}
